import { useEffect, useRef, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

/** Ping can be dismissed back to its project throughout the invoice flow. */
export function CheckoutFrame({ ping, busy = false, onClose, children }: {
  ping: boolean; busy?: boolean; onClose: () => void; children: ReactNode;
}) {
  const { t } = useTranslation();
  const dialog = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!ping) return;
    const previous = document.activeElement as HTMLElement | null;
    dialog.current?.focus();
    return () => { if (previous?.isConnected) previous.focus(); };
  }, [ping]);
  if (!ping) return <div className="checkout-page"><div className="checkout-card">{children}</div></div>;
  return <div className="modal d-block payment-picker-backdrop ping-checkout-dialog" role="dialog" aria-modal="true"
    aria-labelledby="ping-checkout-heading" tabIndex={-1} ref={dialog}
    onClick={event => { if (event.target === event.currentTarget && !busy) onClose(); }}
    onKeyDown={event => {
      if (event.key === 'Escape' && !busy) { event.preventDefault(); onClose(); }
      if (event.key !== 'Tab') return;
      const controls = Array.from(dialog.current?.querySelectorAll<HTMLElement>('button:not(:disabled), a[href], input:not(:disabled), select:not(:disabled), summary, [tabindex="0"]') ?? []).filter(control => control.getClientRects().length > 0);
      const first = controls[0], last = controls[controls.length - 1];
      if (!first) { event.preventDefault(); return; }
      if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog.current)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || document.activeElement === dialog.current)) { event.preventDefault(); first.focus(); }
    }}>
    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-fullscreen-sm-down"
      onClick={event => { if (event.target === event.currentTarget && !busy) onClose(); }}>
      <div className="modal-content">
        <header className="modal-header">
          <h2 className="modal-title h5" id="ping-checkout-heading">{t('projectFunding.picker.title')}</h2>
          <button type="button" className="btn-close p-3" disabled={busy} aria-label={t('projectFunding.closeAriaLabel')} onClick={onClose} />
        </header>
        <div className="modal-body p-0">{children}</div>
      </div>
    </div>
  </div>;
}
